import { AppointmentAggregatesResponse } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { useTranslation } from 'react-i18next';
import {
  EditAverageProductionModal,
  KpiCardProps,
  KpiCardsContainer,
  useAverageProductionAmount,
  useHasAdminAccess,
} from '@frontend/analytics-shared';
import { formatters } from '@frontend/shared';
import { theme } from '@frontend/theme';

interface Props {
  aggregatesData: AppointmentAggregatesResponse | undefined;
  aggregatesDataLoading: boolean;
}
export const KPICards = (props: Props) => {
  const { aggregatesData, aggregatesDataLoading } = props;
  const hasAdminAccess = useHasAdminAccess();
  const { averageProductionAmount } = useAverageProductionAmount();
  const { t } = useTranslation('analytics');

  const data = aggregatesData?.data ? aggregatesData.data[0] : undefined;
  const appointmentsScheduled = data?.totalAppointments ?? 0;
  const appointmentsCompleted = data?.completedAppointments ?? 0;
  const appointmentsCompletedPercentage =
    appointmentsScheduled > 0 ? ((appointmentsCompleted / appointmentsScheduled) * 100).toFixed(1) : '0';
  const productionValue = appointmentsCompleted * (averageProductionAmount?.value ?? 0);

  const kpiConfig: KpiCardProps[] = [
    {
      title: t('Appointments Scheduled'),
      infoTipData: { description: t('Total number of appointments scheduled') },
      value: formatters.value(appointmentsScheduled),
      iconData: {
        name: 'calendar-small',
        bgColor: theme.colors.primary10,
        color: theme.colors.primary50,
      },
      isLoading: aggregatesDataLoading,
    },
    {
      title: t('Appointments Completed'),
      infoTipData: { description: t('Total number of appointments completed') },
      value: formatters.value(appointmentsCompleted),
      subValueText: `(${appointmentsCompletedPercentage}%)`,
      iconData: {
        name: 'check-small',
        bgColor: theme.colors.success5,
        color: theme.colors.success50,
      },
      isLoading: aggregatesDataLoading,
    },
    {
      title: t('Est Production'),
      infoTipData: { description: t('Estimated production ($) from scheduled appointments') },
      value: productionValue > 9999 ? `$${formatters.shortenNumber(productionValue)}` : `$${productionValue}`,
      iconData: {
        name: 'dollar-sign-small',
        bgColor: theme.colors.success5,
        color: theme.colors.success50,
      },
      EditKpiCardData: {
        isEditable: hasAdminAccess,
        text: t('$ {{value}} avg per appointment', { value: averageProductionAmount?.value ?? 0 }),
        onClickComponent: EditAverageProductionModal,
      },
      isLoading: aggregatesDataLoading,
    },
  ];
  return <KpiCardsContainer isLoading={aggregatesDataLoading} kpiConfig={kpiConfig} />;
};
